<template>
  <div class="t-flex t-flex-col t-space-y-2 t-bg-white t-border t-border-gray-200 t-shadow-lg t-py-4 t-px-4 md:t-space-x-2 md:t-w-full md:t-flex-row md:t-space-y-0 md:t-justify-between md:t-rounded-lg">
    <div class="t-flex t-flex-shrink-0 t-w-20">
      <div class="t-inline-block ">
        <div class="t-flex" style="position: relative;">
          <div class="dropdown" style="margin: 0px 0px 0px 10px;">
            <button role="button" type="button" class="btn" :class="[
            { 'btn-warning t-bg-orange with-half-radius': consignment.status_human === 'Booked' },
            { 'btn-info t-bg-dodger-bluewith-half-radius': consignment.status_human === 'In Transit' },
            { 'btn-success t-bg-forest-green with-full-radius': consignment.status_human === 'Delivered' }
          ]" data-toggle="dropdown"
                    :disabled="consignment.status_human === 'Delivered'">
              {{ consignment.status_human }}
            </button>

            <div class="dropdown-menu">
              <a v-if="consignment.status_human === 'Booked'" class="dropdown-item" @click="setNewStatus('In Transit')"><i class="fa fa-square" style="color: blue;"></i>In Transit</a>
              <a v-if="consignment.status_human === 'Booked' || consignment.status_human === 'In Transit'" class="dropdown-item" @click="setNewStatus('Delivered')"><i class="fa fa-square" style="color: green;"></i>Delivered</a>
            </div>
          </div>
          <div v-if="showDate" style="position: absolute;
            top: 40px;
            left: 12px;
            background: #fff;
            border: 1px solid #ccc;
            padding: 10px;
            z-index: 10000;">
            <h2 style="margin-bottom: 10px;">SELECT DATE AND TIME {{ (consignment.status_human === 'Booked') ? 'PICKED UP' : 'DELIVERED' }}</h2>
            <div class="t-flex">
              <v-date-picker v-model="statusDate" mode="dateTime" />
              <div style="flex-direction: column; padding-left: 10px;">
                <button class="btn btn-primary" style="width: 100%;margin-bottom: 10px;" @click="updateStatusWithDate(consignment)">Update</button>
                <button class="btn btn-danger" style="width: 100%;margin-bottom: 10px;" @click="updateClose">Cancel</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="t-flex t-flex-shrink-0 t-w-16">
      <div class="t-inline-block ">
        <button v-if="consignment.status_human != 'Delivered'" role="button" type="button" style="color: #fff;" class="btn" :class="[
            { 'btn-warning t-bg-orange': consignment.status_human === 'Booked' },
            { 'btn-info t-bg-dodger-blue': consignment.status_human === 'In Transit' },
            { 'btn-success t-bg-forest-green': consignment.status_human === 'Delivered' }
          ]" @click="updateStatus(consignment, nextStatus(consignment.status_human))"
                :disabled="consignment.status_human === 'Delivered'" >
          <i class="fas fa-angle-right"></i>
        </button>
      </div>

    </div>
    <div class="t-flex t-flex-shrink-0 t-w-24">
      <span class="t-text-lg t-font-medium">{{ consignment.number }}</span>
    </div>
    <div class="t-w-48 t-flex-col t-flex-grow">
      <p class="t-block md:t-hidden t-text-sm t-uppercase t-tracking-wide t-text-dodger-blue t-font-semibold">
        From
      </p>
      <p class="t-font-medium">{{ consignment.pickup_location.name }}</p>
      <p>{{ consignment.pickup_location.address.street_number }} {{ consignment.pickup_location.address.street_name }}</p>
      <p>{{ consignment.pickup_location.address.suburb }}</p>
      <p>{{ consignment.pickup_location.address.region }}</p>
    </div>
    <div class="t-w-48 t-flex-col t-flex-grow">
      <p class="t-block md:t-hidden t-text-sm t-uppercase t-tracking-wide t-text-dodger-blue t-font-semibold">
        To
      </p>
      <p class="t-font-medium">{{ consignment.delivery_location.name }}</p>
      <p>{{ consignment.delivery_location.address.street_number }} {{
          consignment.delivery_location.address.street_name
        }} </p>
      <p>{{ consignment.delivery_location.address.suburb }}</p>
      <p>{{ consignment.delivery_location.address.city }}</p>
    </div>
    <div class="t-w-30 t-flex-grow">
      <div v-if="consignment.pickup_before">
        <p><strong>Before</strong>: {{ moment(consignment.pickup_before).format('hh:mm A ddd DD MMM') }}</p>
        <p><strong>After</strong>: {{ moment(consignment.pickup_after).format('hh:mm A ddd DD MMM') }}</p>
      </div>
      <div v-else>
        <p class="t-block md:t-hidden t-text-sm t-uppercase t-tracking-wide t-text-dodger-blue t-font-semibold">
          Pickup After
        </p>
        {{ moment(consignment.pickup_after).format('hh:mm A ddd DD MMM') }}
      </div>
    </div>
    <div class="t-w-30 t-flex-grow">
      <p v-if="consignment.deliver_before" class="t-block md:t-hidden t-text-sm t-uppercase t-tracking-wide t-text-dodger-blue t-font-semibold">
        Deliver Before
      </p>
      {{ consignment.deliver_before ? moment(consignment.deliver_before).format('hh:mm A ddd DD MMM') : '' }}
    </div>
    <div class="t-w-20">
      ${{ consignment.price }}
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker
  },
  name: 'ConsignmentCardCompact',
  description: '',
  props: {
    consignment: {
      type: Object
    }
  },
  data() {
    return {
      statusDate: moment().format("YYYY-MM-DD HH:mm"),
      newStatus: null,
      showDate: false
    }
  },
  methods: {
    moment(...args) {
      return moment(...args);
    },

    setNewStatus(status) {
      this.newStatus = status;
      this.showDate = true;
    },

    updateStatusWithDate(consignment) {
      switch (this.newStatus) {
        case 'In Transit':
          this.updatePickedUp(consignment);
          break;

        case 'Delivered':
          this.updateDelivered(consignment);
          break;

        case 'Cancel':
          this.updateCancel(consignment);
          break;
      }
    },

    updateStatus(consignment, statusHuman) {
      switch (statusHuman) {
        case 'In Transit':
          this.updatePickedUp(consignment);
          break;

        case 'Delivered':
          this.updateDelivered(consignment);
          break;

        case 'Cancel':
          //this.updateCanceled(consignment);
          break;
      }
    },

    updatePickedUp(consignment) {
      const dateTime = moment(this.statusDate);
      const dateTimeString = dateTime.format("ddd D MMM gggg h A");

      axios
        .put("/carry-freight/bookings/" + consignment.id + "/pickup", {
          pickup_time: dateTimeString
        })
        .then((response) => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: 'success',
            });
            this.$parent.fetchConsignments(this.$parent.page);
            /*location.reload();*/
          } else {
            this.$swal({
              title: data.message,
              type: 'error'
            });
          }
        })
        .catch((error) => {
          Event.$emit("serverError");
        });
    },

    updateDelivered(consignment) {
      const dateTime = moment(this.statusDate);
      const dateTimeString = dateTime.format("ddd D MMM gggg h A");

      axios
        .put("/carry-freight/bookings/" + consignment.id + "/delivered", {
          pickup_time: dateTimeString
        })
        .then((response) => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: 'success',
            });
            this.$parent.fetchConsignments(this.$parent.page);
            /*location.reload();*/
          } else {
            this.$swal({
              title: data.message,
              type: 'error'
            });
          }
        })
        .catch((error) => {
          Event.$emit("serverError");
        });
    },

    updateCancel() {
      const dateTime = moment(this.statusDate);
      const dateTimeString = dateTime.format("ddd D MMM gggg h A");

      axios
        .put("/carry-freight/bookings/" + consignment.id + "/cancel", {
          update_time: dateTimeString
        })
        .then((response) => {
          let data = response.data;

          if (data.is_success) {
            this.$swal({
              title: data.message,
              type: 'success',
            });
            this.$parent.fetchConsignments(this.$parent.page);
            /*location.reload();*/
          } else {
            this.$swal({
              title: data.message,
              type: 'error'
            });
          }
        })
        .catch((error) => {
          Event.$emit("serverError");
        });
    },

    nextStatus(statusHuman) {
      if (statusHuman === "Booked") {
        return "In Transit";
      } else if (statusHuman === "In Transit") {
        return "Delivered";
      }
    },

    updateClose() {
      this.newStatus = null;
      this.showDate = false;
    },
  }
}
</script>

<style scoped>
  .with-half-radius {
    color: #fff;
    border-radius: 5px 0px 0px 5px;
    white-space: nowrap;
  }

  .with-full-radius {
    color: #fff;
    border-radius: 5px;
    white-space: nowrap;
  }
</style>
